import React from 'react';
import { useAppSelector } from 'hooks';
import { Link as ReactRouterLink, LinkProps as reactRouterLinkProps } from 'react-router-dom';

import { selectHasParent } from '~main/selectors/app';

export interface ComponentProps extends reactRouterLinkProps {
  disabled?: boolean;
  dataCy?: string;
}

const Link: React.FC<ComponentProps> = ({ children, dataCy, disabled, target, ...props }) => {
  const hasParent = useAppSelector(selectHasParent);

  let linkTarget = target;
  if (!target && hasParent) linkTarget = '_parent';

  return (
    <>
      {disabled && children}
      {!disabled && (
        <ReactRouterLink data-cy={dataCy} target={linkTarget} {...props}>
          {children}
        </ReactRouterLink>
      )}
    </>
  );
};

export default Link;
